/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { beneSuccessDetail } from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";

import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import CommonToast from "../../../../components/_utils/CommonToast";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const FieldForceContactSuccess = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const successDetail = useSelector(
    (state) => state.beneCreateAccount.beneSuccessData,
  );
  const isSuccessErrorData = useSelector(
    (state) => state.beneCreateAccount.isSuccessErrorData,
  );

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const viewDetailsHandler = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };
  const dashboardHandler = () => {
    navigate("/field_force_account_dashboard");
  };

  const createTxn = () => {
    CommonToast({
      text: "Feature coming soon",
      icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
      variant: "var(--coming-soon)",
      buttonNeeded: false,
    });
  };

  const beneficiaryAccount = successDetail?.beneficiary_accounts[0] || {};

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: createTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/create_new_account.svg",
        handleFunction: () => {
          navigate(`/field_force_account_dashboard/create_field_force_account`);
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    if (isSuccessErrorData === "Request failed with status code 404") {
      navigate("*");
    }
  }, [isSuccessErrorData]);

  useEffect(() => {
    dispatch(beneSuccessDetail(id));
  }, [dispatch, id]);

  return (
    <>
      <div>
        <StatusContainer
          status="success"
          hoverOption="white"
          buttonRows={buttonRows}
          title={`
      Contact details updated successfully.`}
        >
          <TabsWeapperSection title="Account details">
            <>
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: beneficiaryAccount?.name ?? "Not available",
                    leftSubTitle: "Account name",
                  },
                ]}
              />
              <InfoCard
                bgColor="var(--positive-card)"
                hoverable="black"
                rows={[
                  {
                    leftTitle:
                      typeof beneficiaryAccount.category === "string"
                        ? beneficiaryAccount.category
                            .split(",")
                            .map((category) => category.trim())
                            .join(" , ")
                        : beneficiaryAccount.category,
                    leftSubTitle: "Assigned categories",
                  },
                ]}
              />
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: beneficiaryAccount?.pan_no,
                    leftSubTitle: "PAN number",
                  },
                ]}
              />
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: formatAccountNumber(
                      beneficiaryAccount?.bank_acc_no,
                    ),
                    leftSubTitle: "Account number",
                    ifsc: beneficiaryAccount?.ifsc_code,
                  },
                ]}
              />
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: beneficiaryAccount?.ifsc_code,
                    leftSubTitle: "IFSC code",
                    // ifsc: beneficiaryAccount?.ifsc_code,
                  },
                ]}
              />
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: beneficiaryAccount?.contact_no
                      ? `+91 ${beneficiaryAccount.contact_no}`
                      : "Not available",
                    leftSubTitle: "Contact number",
                    icon: "https://q2pay.in/new_assets/common/create_flow/contact_number.svg",
                  },
                ]}
              />
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: beneficiaryAccount?.email_id || "Not available",
                    leftSubTitle: "Email ID",
                    icon: "https://q2pay.in/new_assets/common/create_flow/gmail_red_error.svg",
                  },
                ]}
              />
              {beneficiaryAccount?.gstin_detail && (
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: beneficiaryAccount.gstin_detail,
                      leftSubTitle: "GSTIN (optional)",
                    },
                  ]}
                />
              )}

              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: "Will come from API",
                    leftSubTitle: "Linked user",
                  },
                ]}
              />
            </>
          </TabsWeapperSection>
        </StatusContainer>
      </div>
    </>
  );
};

export default FieldForceContactSuccess;
